
export const addField = (field, value) => (
  (dispatch) => {
    dispatch({type: 'FIELD_VALUE', field: field, value: value});
  }
);

export const deleteField = (field) => (
  (dispatch) => {
    dispatch({type: 'DELETE_FIELD', field: field})
  }
);

export const clearFields = () => (
  (dispatch) => {
    dispatch({type: 'CLEAR_FIELDS'})
  }
);


// WEBPACK FOOTER //
// ./src/actions/field-action.js